"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildtryExecute = void 0;
const try_execute_1 = require("./try-execute");
function buildtryExecute(errorHandler) {
    return (fn, ...args) => (0, try_execute_1.tryExecute)(errorHandler, fn, ...args);
}
exports.buildtryExecute = buildtryExecute;
